import { cn } from '@/platform/lib/utils';
import { TabList as HeadlessTabList } from '@headlessui/react';

const TabList = ({ className, children, ...props }) => (
    <HeadlessTabList
        className={cn('flex gap-x-6 border-b border-gray-200', className)}
        {...props}
    >
        {children}
    </HeadlessTabList>
);

export default TabList;
